import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { translate, getLanguage } from 'react-switch-lang';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NewHeader from './newHeader.js';
import Footer from './Footer.js';
import * as myConstClass from './constant.js';
import { cartHasProducts, cartHasMagazines, cartHasRegularEvents, getCartConflictMessage } from './constant.js';
import { updateGuestCartDisplay, getGuestCartConflictMessage } from './utils/guestCartHelpers';
import EventFilters from './components/eventListing/EventFilters.jsx';
import EventListingHero from './components/eventListing/EventListingHero';
import SelectedCategoryInfo from './components/eventListing/SelectedCategoryInfo';
import MachineTestCard from './components/MachineTestCard.jsx';
import './MachineTestListingPage.css';
import $ from 'jquery';

class MachineTestListingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryName: 'Machine Tests',
            categoryId: '3',
            machineTests: [],
            filteredMachineTests: [],
            allLoadedTests: [], // Store all loaded tests
            displayedTestsCount: 6, // Number of tests to display initially (2 rows of 3)
            loading: false,
            loadingMore: false,
            hasMoreTests: false,
            filters: {
                events: ['Machine Tests'],
                topics: ['All'],
                language: 'All',
                subTopics: ['All']
            },
            pagination: {
                page: 1,
                pageSize: 20,
                totalCount: 0,
                totalPages: 0,
                hasNextPage: false,
                hasPreviousPage: false
            },
            filterOptions: {
                eventTypes: [],
                topics: [],
                ageGroups: []
            },
            eventTypeDescription: '' // Store event type description from API
        };
        
        this.scrollContainerRef = React.createRef();
        this.loadMoreObserver = null;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        
        // Get topic ID from URL parameters (if any)
        const { topicId } = this.props.match.params;
        
        console.log('MachineTestListingPage - URL params:', this.props.match.params);
        console.log('MachineTestListingPage - topicId from URL:', topicId);
        
        // Initialize filters based on URL params
        const initialFilters = {
            events: ['Machine Tests'],
            topics: topicId ? [topicId] : ['All'], // If topic ID provided, filter by it
            language: 'All',
            subTopics: ['All']
        };
        
        console.log('MachineTestListingPage - Initial filters:', initialFilters);
        
        this.setState({
            filters: initialFilters
        });
        
        // Fetch filter options and event type description, then fetch machine tests
        Promise.all([
            this.fetchFilterOptions(),
            this.fetchEventTypeDescription('3', getLanguage())
        ]).then(() => {
            this.fetchMachineTests(initialFilters, this.state.pagination, true);
        });
    }

    componentWillUnmount() {
        // Clean up intersection observer
        if (this.loadMoreObserver) {
            this.loadMoreObserver.disconnect();
        }
    }

    // Setup intersection observer for lazy loading
    setupLazyLoadingObserver = () => {
        if (this.loadMoreObserver) {
            this.loadMoreObserver.disconnect();
        }
        
        this.loadMoreObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    // Check if there are more tests to display (either from loaded or from API)
                    const { allLoadedTests, displayedTestsCount, loadingMore } = this.state;
                    const hasMoreToDisplay = allLoadedTests.length > displayedTestsCount;
                    
                    if (entry.isIntersecting && !loadingMore && hasMoreToDisplay) {
                        this.loadMoreTests();
                    }
                });
            },
            {
                root: null,
                rootMargin: '200px',
                threshold: 0.1
            }
        );
        
        const loadMoreTrigger = document.getElementById('load-more-trigger');
        if (loadMoreTrigger) {
            this.loadMoreObserver.observe(loadMoreTrigger);
        }
    }

    // Load more tests (lazy loading)
    loadMoreTests = async () => {
        const { allLoadedTests, displayedTestsCount, filters, pagination, hasMoreTests, loadingMore } = this.state;
        
        if (loadingMore) return;
        
        const nextDisplayCount = displayedTestsCount + 6; // 2 rows of 3 cards
        const remainingInLoaded = allLoadedTests.length - displayedTestsCount;
        
        // If we have tests already loaded that haven't been displayed yet, show them
        if (remainingInLoaded > 0 && !hasMoreTests) {
            this.increaseDisplayedCount();
            return;
        }
        
        // If we have enough tests already loaded, just increase the display count
        if (remainingInLoaded >= 8) {
            this.increaseDisplayedCount();
            return;
        }
        
        // If we need more tests and there are more available, fetch from API
        if (hasMoreTests && remainingInLoaded < 10) {
            this.setState({ loadingMore: true });
            
            try {
                const nextPage = pagination.page + 1;
                const nextPagination = { ...pagination, page: nextPage };
                
                await this.fetchMachineTests(filters, nextPagination, false);
            } catch (error) {
                console.error('Error loading more machine tests:', error);
                this.setState({ loadingMore: false });
            }
        } else if (!hasMoreTests) {
            // No more tests to load
            this.setState({ loadingMore: false });
        }
    }

    // Increase the number of displayed tests
    increaseDisplayedCount = () => {
        this.setState(prevState => ({
            displayedTestsCount: prevState.displayedTestsCount + 6 // 2 rows of 3 cards
        }), () => {
            setTimeout(() => this.setupLazyLoadingObserver(), 100);
        });
    }

    // Fetch event type description from API (same as old Machine_test.js)
    fetchEventTypeDescription = async (eventTypeId, language) => {
        if (!eventTypeId) return null;
        
        try {
            const userId = localStorage.getItem('user_id') || '0';
            const apiUrl = `${myConstClass.BASE_URL}event/getEventTypeDetails/${language}/${eventTypeId}/${userId}`;
            console.log('Fetching event type description from:', apiUrl);
            
            const response = await fetch(apiUrl);
            const data = await response.json();
            
            console.log('Event type description API response:', data);
            
            // API returns array with event type details
            if (Array.isArray(data) && data.length > 0) {
                const eventTypeData = data[0];
                // The field is called 'event_description' not 'description_mr' or 'description_en'
                const description = eventTypeData.event_description || eventTypeData.description || '';
                
                this.setState({ eventTypeDescription: description });
                console.log('Stored event type description:', description);
                return description;
            }
            return null;
        } catch (error) {
            console.error('Error fetching event type description:', error);
            return null;
        }
    }

    // Fetch filter options from API
    fetchFilterOptions = async () => {
        try {
            // Use the same Node API endpoint as EventListingPage
            const apiUrl = `${myConstClass.NODE_API_BASE}/event/filterOptions`;
            console.log('Fetching filter options from:', apiUrl);

            const response = await fetch(apiUrl);
            const data = await response.json();

            if (data && data.status === 'true' && data.data) {
                this.setState({
                    filterOptions: {
                        eventTypes: data.data.eventTypes || [],
                        topics: data.data.topics || [],
                        ageGroups: data.data.ageGroups || [],
                        cities: data.data.cities || [],
                        states: data.data.states || [],
                        countries: data.data.countries || [],
                        trusts: data.data.trusts || []
                    }
                });
                return data.data;
            } else if (data) {
                // Fallback to older shape if node API returns different structure
                this.setState({
                    filterOptions: {
                        eventTypes: data.eventTypes || [],
                        topics: data.topics || [],
                        ageGroups: data.ageGroups || []
                    }
                });
                return data;
            }
        } catch (error) {
            console.error('Error fetching filter options:', error);
        }
    }

    // Fetch machine tests from API
    fetchMachineTests = async (filters = null, pagination = null, isInitialLoad = false) => {
        const currentFilters = filters || this.state.filters;
        const currentPagination = pagination || { ...this.state.pagination, page: 1 };
        
        if (isInitialLoad) {
            this.setState({ 
                loading: true,
                allLoadedTests: [],
                displayedTestsCount: 6, // 2 rows of 3 cards
                hasMoreTests: true
            });
        } else {
            this.setState({ loadingMore: true });
        }

        try {
            const userId = localStorage.getItem('user_id') || '0';
            const eventType = '3'; // Machine Tests event type ID
            
            // Get topic ID from filters if specified
            // When "All" is selected, pass undefined to fetch all topics (like old implementation)
            let topicId = undefined;
            if (currentFilters.topics && currentFilters.topics.length > 0 && !currentFilters.topics.includes('All')) {
                // Map topic name to ID using filterOptions
                const topicName = currentFilters.topics[0];
                const topic = this.state.filterOptions.topics.find(t => 
                    t.name === topicName || t.nameEn === topicName || t.label === topicName
                );
                topicId = topic ? (topic.topicId || topic.id) : undefined;
            }
            
            const apiUrl = `${myConstClass.BASE_URL}event/getEventsFrontEnd/${getLanguage()}/${eventType}/${topicId}/0/${userId}`;
            console.log('Fetching machine tests from:', apiUrl);
            
            const response = await fetch(apiUrl);
            const data = await response.json();
            
            console.log('Machine tests API response:', data);
            
            // Extract machine tests from response
            // When "All" topics is selected, API returns array of topic groups, each with arr_events
            // We need to collect events from all topic groups
            let machineTests = [];
            if (Array.isArray(data) && data.length > 0) {
                // Iterate through all topic groups and collect their events
                data.forEach(topicGroup => {
                    if (topicGroup && topicGroup.arr_events && Array.isArray(topicGroup.arr_events)) {
                        machineTests = machineTests.concat(topicGroup.arr_events);
                    }
                });
            }
            
            console.log('Extracted machine tests:', machineTests.length);
            
            // Update state with fetched data
            if (isInitialLoad) {
                this.setState({
                    machineTests: machineTests,
                    filteredMachineTests: machineTests,
                    allLoadedTests: machineTests,
                    loading: false,
                    hasMoreTests: false, // Machine tests API doesn't use pagination
                    pagination: {
                        ...currentPagination,
                        totalCount: machineTests.length,
                        totalPages: 1,
                        hasNextPage: false,
                        hasPreviousPage: false
                    }
                }, () => {
                    // Setup lazy loading observer after initial load
                    setTimeout(() => this.setupLazyLoadingObserver(), 500);
                });
            } else {
                // Append to existing tests
                this.setState(prevState => ({
                    allLoadedTests: [...prevState.allLoadedTests, ...machineTests],
                    loadingMore: false,
                    hasMoreTests: false,
                    pagination: {
                        ...currentPagination,
                        totalCount: prevState.allLoadedTests.length + machineTests.length
                    }
                }), () => {
                    setTimeout(() => this.setupLazyLoadingObserver(), 100);
                });
            }
        } catch (error) {
            console.error('Error fetching machine tests:', error);
            this.setState({
                loading: false,
                loadingMore: false,
                hasMoreTests: false
            });
            toast.error('Failed to load machine tests. Please try again.');
        }
    }

    handleFilterChange = (filters) => {
        console.log('Filters changed:', filters);
        this.setState({ 
            filters,
            pagination: { ...this.state.pagination, page: 1 },
            displayedTestsCount: 8,
            allLoadedTests: []
        });
        
        // Fetch machine tests with new filters
        this.fetchMachineTests(filters, { ...this.state.pagination, page: 1 }, true);
    }

    // Add machine test to cart
    handleAddToCart = async (eventId, quantity, topicId) => {
        const userId = localStorage.getItem('user_id');
        
        console.log('Adding machine test to cart:', { eventId, quantity, topicId, userId });
        
        if (quantity <= 0) {
            const message = getLanguage() === 'ma' ? 'कृपया सहभागींची संख्या निवडा.' : 'Please select the number of participants.';
            toast.error(message);
            return;
        }
        
        if (!userId || userId === '0') {
            // Guest user - store in localStorage
            try {
                // Check for cart conflicts - machine tests can't mix with regular events
                const conflictMessage = getGuestCartConflictMessage('event', getLanguage);
                if (conflictMessage) {
                    toast.error(conflictMessage);
                    return;
                }
                
                const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
                const machineTest = this.state.allLoadedTests.find(mt => mt.event_id == eventId);
                
                if (!machineTest) {
                    toast.error('Machine test not found');
                    return;
                }
                
                // Check if this machine test is already in cart
                const existingIndex = guestEvents.findIndex(item => 
                    item.event_id == eventId && item.topic_id == topicId
                );
                
                if (existingIndex !== -1) {
                    // Update quantity
                    guestEvents[existingIndex].parent = parseInt(guestEvents[existingIndex].parent || 0) + parseInt(quantity);
                    // Ensure all required fields are present
                    if (!guestEvents[existingIndex].first_price_for) {
                        guestEvents[existingIndex].first_price_for = machineTest.first_price_for || 'Person';
                    }
                    if (!guestEvents[existingIndex].second_price) {
                        guestEvents[existingIndex].second_price = machineTest.second_price || machineTest.first_price;
                    }
                } else {
                    // Add new item
                    guestEvents.push({
                        event_id: eventId,
                        event_type: 'Machine Test',
                        event_type_id: 3,
                        topic_id: topicId,
                        parent: parseInt(quantity),
                        child: 0,
                        title: machineTest.title,
                        price: machineTest.first_price,
                        first_price: machineTest.first_price,
                        second_price: machineTest.second_price || machineTest.first_price,
                        child_price: machineTest.second_price || machineTest.first_price,
                        first_price_for: machineTest.first_price_for || 'Person',
                        added_at: new Date().toISOString()
                    });
                }
                
                localStorage.setItem('guest_cart_events', JSON.stringify(guestEvents));
                localStorage.setItem('isMachineTestMode', 'true');
                
                // Update cart display
                updateGuestCartDisplay();
                
                // Update machine test state to show it's in cart
                this.setState(prevState => ({
                    allLoadedTests: prevState.allLoadedTests.map(mt =>
                        mt.event_id == eventId
                            ? { ...mt, added_in_cart: [{ cart_id: 1 }] }
                            : mt
                    )
                }));
                
                toast.success('Machine test added to cart successfully');
            } catch (error) {
                console.error('Error adding machine test to guest cart:', error);
                toast.error('Unable to add machine test to cart');
            }
        } else {
            // Logged-in user - make API call
            try {
                // Check if cart has products or magazines - if so, show conflict message
                const [hasProducts, hasMagazines, hasRegularEvents] = await Promise.all([
                    cartHasProducts(userId),
                    cartHasMagazines(userId),
                    cartHasRegularEvents(userId)
                ]);
                
                // Machine tests can coexist with other machine tests but not with regular events
                if (hasProducts || hasMagazines || hasRegularEvents) {
                    const conflictMessage = getCartConflictMessage(false, hasProducts, hasMagazines, getLanguage);
                    toast.error(conflictMessage);
                    return;
                }
                
                // Build API parameters
                const params = {
                    event_id: eventId,
                    language_id: getLanguage() === 'ma' ? 2 : 1,
                    topic_id: topicId || 0,
                    event_type_id: 3,
                    schedule_id: 0,
                    parent_topic_id: 0
                };
                
                // Make multiple API calls based on quantity (similar to old Machine_test.js)
                const addToCartPromises = [];
                for (let i = 0; i < quantity; i++) {
                    const apiUrl = `${myConstClass.BASE_URL}cart/addeventtoCart/${params.event_id}/${params.language_id}/${params.topic_id}/${params.event_type_id}/${params.schedule_id}/${params.parent_topic_id}/${userId}`;
                    addToCartPromises.push(fetch(apiUrl).then(res => res.json()));
                }
                
                const responses = await Promise.all(addToCartPromises);
                
                // Check if all requests succeeded
                const allSuccess = responses.every(res => res.status === 'true');
                
                if (allSuccess) {
                    toast.success('Machine test added to cart successfully');
                    
                    // Update machine test state to show it's in cart
                    this.setState(prevState => ({
                        allLoadedTests: prevState.allLoadedTests.map(mt =>
                            mt.event_id == eventId
                                ? { ...mt, added_in_cart: [{ cart_id: 1 }] }
                                : mt
                        )
                    }));
                    
                    // Update cart count in header
                    fetch(`${myConstClass.BASE_URL}cart/getTotalCartCount/${userId}`)
                        .then(res => res.json())
                        .then(countResponse => {
                            const totalCartCount = countResponse.totalcartcount || 0;
                            const cartCountElements = document.querySelectorAll('.lblCartCount');
                            cartCountElements.forEach(el => {
                                el.textContent = totalCartCount;
                            });
                        })
                        .catch(err => console.error('Error updating cart count:', err));
                } else {
                    toast.error('Failed to add machine test to cart');
                }
            } catch (error) {
                console.error('Error adding machine test to cart:', error);
                toast.error('Unable to add machine test to cart');
            }
        }
    }

    render() {
        const { t } = this.props;
        const { loading, allLoadedTests, displayedTestsCount, loadingMore, hasMoreTests, filters, eventTypeDescription } = this.state;
        
        // Get tests to display (slice from allLoadedTests based on displayedTestsCount)
        const testsToDisplay = allLoadedTests.slice(0, displayedTestsCount);
        
        // Default description if API doesn't return one
        const description = eventTypeDescription || "Test your knowledge and understanding through our scientifically designed machine tests that provide instant feedback and personalized recommendations.";

        return (
            <div className="machine-test-listing-page">
                <ToastContainer />
                <NewHeader />
                
                {/* Hero Section with Description */}
                <EventListingHero 
                    categoryName="Machine Tests"
                    categoryId="3"
                    description={description}
                />
                
                <div className="container-fluid machine-test-container">
                    <div className="container-xl">
                        <div className="row">
                            {/* Filters Sidebar */}
                            <div className="col-12 col-md-4 col-lg-3 mb-4">
                                <EventFilters 
                                    onFilterChange={this.handleFilterChange}
                                    initialFilters={filters}
                                    filterOptions={this.state.filterOptions}
                                />
                            </div>
                            
                            {/* Machine Tests Content */}
                            <div className="col-12 col-md-8 col-lg-9">
                                {/* Category Info with Description */}
                                <SelectedCategoryInfo 
                                    categoryName="Machine Tests"
                                    description={description}
                                />
                                
                                <div className="machine-test-content">
                                    
                                    {/* Loading State */}
                                    {loading && (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            <p className="mt-2">Loading machine tests...</p>
                                        </div>
                                    )}

                                    {/* Machine Tests List */}
                                    {!loading && (
                                        <>
                                            {testsToDisplay.length > 0 ? (
                                                <>
                                                    <div className="machine-test-list">
                                                        {testsToDisplay.map((machineTest, index) => (
                                                            <MachineTestCard 
                                                                key={machineTest.event_id || index}
                                                                machineTest={machineTest}
                                                                onAddToCart={this.handleAddToCart}
                                                            />
                                                        ))}
                                                    </div>
                                                    
                                                    {/* Lazy Loading Trigger */}
                                                    {(hasMoreTests || allLoadedTests.length > displayedTestsCount) && (
                                                        <>
                                                            <div id="load-more-trigger" style={{ height: '20px', marginTop: '20px' }}></div>
                                                            
                                                            {/* Manual Load More Button */}
                                                            <div className="text-center mt-4 mb-4">
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={this.loadMoreTests}
                                                                    disabled={loadingMore}
                                                                >
                                                                    {loadingMore ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                            Loading...
                                                                        </>
                                                                    ) : (
                                                                        'Load More Machine Tests'
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </>
                                                    )}
                                                    
                                                    {/* All Loaded Message */}
                                                    {!hasMoreTests && allLoadedTests.length <= displayedTestsCount && allLoadedTests.length > 8 && (
                                                        <div className="text-center py-3">
                                                            <p className="text-muted">All machine tests loaded ({allLoadedTests.length} total)</p>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="text-center py-5">
                                                    <p className="text-muted" id="productNotAvailable">
                                                        {t('home.No machine tests found matching your filters')}
                                                    </p>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

MachineTestListingPage.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withRouter(translate(MachineTestListingPage));
